import React, { useMemo } from "react";
import { FieldArray } from "react-final-form-arrays";
import { Field, useForm, useFormState } from "react-final-form";
import clsx from "clsx";
import { makeStyles, Typography } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";
import Button from "../../../../../components/Button";
import theme from "../../../../../themes";
import InfoIcon from "../../../../../components/InfoIcon";

const useStyles = makeStyles(() => ({
  mainLabel: {
    fontSize: 21,
    fontWeight: "bold",
    color: "#535358",
  },
  examScoreContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  firstEamScoreContainer: {
    marginTop: 16,
  },
  exam: {
    marginBottom: 14,
    width: "50%",
  },
  score: {
    marginLeft: 24,
    width: "50%",
  },
  addNewButton: {
    fontSize: 17,
    fontWeight: "bold",
    height: 44,
    color: "#fefefe",
    backgroundColor: "#7ec884",
    width: 195,
    padding: "0 10px!important",
  },
  addNewButtonContainer: {
    textAlign: "right",
    marginBottom: 18,
  },
  fieldArrayContainer: {
    display: "flex",
    flexDirection: "column-reverse",
  },
  asterisk: {
    color: "#535358",
    lineHeight: "inherit",
    fontSize: 16,
    fontWeight: "normal",
    marginLeft: 3,
  },
  hasError: {
    color: theme.palette.error.main,
  },
}));

function Exams({ stepName, required, infoIcon = "" }) {
  const classes = useStyles();
  const formData = useFormState();
  const {
    mutators: { push },
  } = useForm();

  const { submitFailed, dirtySinceLastSubmit, invalid } = formData;
  const hasFormError = useMemo(
    () => invalid && submitFailed && !dirtySinceLastSubmit,
    [invalid, dirtySinceLastSubmit, submitFailed],
  );
  const intakeErrors =
    formData.submitErrors?.[stepName];
  const hasError =
    intakeErrors?.exams ||
    intakeErrors?.mainExams.length ||
    intakeErrors?.addedExams.length;

  return (
    <div>
      <div className={classes.mainLabel}>
        Exams
        {required && (
          <Typography
            className={clsx(
              classes.asterisk,
              hasFormError && hasError && classes.hasError,
            )}
            component={"span"}
            variant={"subtitle2"}
          >
            *
          </Typography>
        )}
        {infoIcon && <InfoIcon text={infoIcon} portalMode={false} />}
      </div>
      <div
        className={clsx(
          classes.examScoreContainer,
          classes.firstEamScoreContainer,
        )}
      >
        <div className={classes.exam}>
          <Field
            fullWidth
            type="text"
            label="Exam"
            placeholder="Exam"
            name={`${stepName}.mainExams.0.name`}
            component={BootstrapInput}
          />
        </div>
        <div className={classes.score}>
          <Field
            fullWidth
            type="text"
            label="Score"
            placeholder="Score"
            name={`${stepName}.mainExams.0.score`}
            component={BootstrapInput}
          />
        </div>
      </div>

      <div className={classes.examScoreContainer}>
        <div className={classes.exam}>
          <Field
            fullWidth
            type="text"
            label="Exam"
            placeholder="Exam"
            name={`${stepName}.mainExams.1.name`}
            component={BootstrapInput}
          />
        </div>
        <div className={classes.score}>
          <Field
            fullWidth
            type="text"
            label="Score"
            placeholder="Score"
            name={`${stepName}.mainExams.1.score`}
            component={BootstrapInput}
          />
        </div>
      </div>

      <div className={classes.addNewButtonContainer}>
        <Button
          color={"success"}
          fullWidth
          onClick={() => push(`${stepName}.addedExams`, undefined)}
          variant="contained"
          className={classes.addNewButton}
        >
          Add Exam
        </Button>
      </div>

      <div className={classes.fieldArrayContainer}>
        <FieldArray name={`${stepName}.addedExams`}>
          {({ fields }) =>
            fields.map((name, i) => {
              return (
                <div key={i} className={classes.examScoreContainer}>
                  <div className={classes.exam}>
                    <Field
                      fullWidth
                      type="text"
                      label="Exam"
                      placeholder="Exam"
                      name={`${name}.name`}
                      component={BootstrapInput}
                    />
                  </div>
                  <div className={classes.score}>
                    <Field
                      fullWidth
                      type="text"
                      label="Score"
                      placeholder="Score"
                      name={`${name}.score`}
                      component={BootstrapInput}
                    />
                  </div>
                </div>
              );
            })
          }
        </FieldArray>
      </div>

      <div className={classes.examScoreContainer}>
        <div className={classes.exam}>
          <Field
            fullWidth
            type="text"
            label="Exam"
            placeholder="Exam"
            name={`${stepName}.mainExams.2.name`}
            component={BootstrapInput}
          />
        </div>
        <div className={classes.score}>
          <Field
            fullWidth
            type="text"
            label="Score"
            placeholder="Score"
            name={`${stepName}.mainExams.2.score`}
            component={BootstrapInput}
          />
        </div>
      </div>
    </div>
  );
}

export default Exams;
